import { InjectionToken } from '@angular/core';

export const SVG_DEF = new InjectionToken<{[key: string]: string}>('SVG_DEF');
export const INITIAL_URL = new InjectionToken<string>('INITIAL_URL');
export const LOADING_URL = new InjectionToken<string>('LOADING_URL');
export const FALLBACK_URL = new InjectionToken<string>('FALLBACK_URL');
